import React, {useEffect, useState} from 'react';
import AdminPage from "pages/app/AdminPage";
import useDepartmentId from "support/hooks/use-department-id";
import {Env} from "@morningtrain/helpers";

export default function Stocktake(props) {
// Local state to store the iframe URL with AuthToken
  if (!Env.get('stocktake_enabled', false)) {
    console.log("sttk",Env.get());
    return null;
  }
  const [iframeUrl, setIframeUrl] = useState('');
  const [departmentId] = useDepartmentId();

  // Function to fetch iframe and auth_token for the current department
  const fetchIframeData = async () => {
    try {
      const response = await axios.get(`/api/getiframe?departmentId=${departmentId}`); // temporary relative hardcoded url
      const {auth_token, iframe_url} = response.data; // Backend should return object with iframe_url and auth_token
      const updatedUrl = `${iframe_url}?authToken=${encodeURIComponent(auth_token)}`;
      setIframeUrl(updatedUrl);
    } catch (error) {
      console.log('Error fetching iFrameData:', error.response.data.e_message);
    }
  };

  // Fetch iFrameData whenever the department changes
  useEffect(() => {
    fetchIframeData();
  }, [departmentId]);

  useEffect(() => {
    // Listener for iframe message posts to dynamically set styles
    const handleIframeMessage = (event) => {
      let iFrame = document.querySelector('#iFrame');

      if (event.data === 'expandIframe') {
        iFrame.className = 'iframe-expanded';
      } else if (event.data === 'shrinkIframe') {
        iFrame.className = 'iframe-shrinked';
      }
    };

    window.addEventListener('message', handleIframeMessage);

    return () => {
      window.removeEventListener('message', handleIframeMessage);
    };
  }, []);

  return (
    <AdminPage withGlobalDepartmentFilter>
      <iframe
        id="iFrame"
        src={iframeUrl} // Dynamically updated iframe URL
        className={'iframe-shrinked'}
      ></iframe>
    </AdminPage>
  );
};
